<template>
  <div class="footer">
    <div class="top">
      <ul>
        <h1>导航</h1>
        <li v-for="(item, index) in navList" :key="index" @click="onIsActive(index)">{{ item.name }}</li>
      </ul>
      <ul>
        <h1>联系我们</h1>
        <li>
          <img src="../../../static/image/footer/dizhi.png" alt="" />
          {{udata.address}}
        </li>
        <li>
          <img src="../../../static/image/footer/dianhua.png" alt="" />
          手机：{{udata.mobile}}
        </li>
        <li>
          <img src="../../../static/image/footer/youxiang.png" alt="" />
          邮箱：{{udata.email}}
        </li>
        <li>
          <img src="../../../static/image/footer/web.png" alt="" />
          网址：<a :href="udata.website" >{{udata.website}}</a>
        </li>
      </ul>
      <div class="code">
        <div>
          <img :src="http+udata.wechat_qrcode" alt="" />
          <p>公众号</p>
        </div>
        <h6>服务热线：{{udata.service_mobile}}</h6>
      </div>
    </div>
    <div class="Links">
      <h1>友情链接： </h1>
      <a  v-for="(item,index) in FriendlyLink" :key="index" :href="item.jump_url">{{item.link_name}}</a>
    </div>
    <div class="RecordNo">
       <p v-html="udata.beian"></p>
    </div>
  </div>
</template>

<script>
import { about,getFriendlyLink } from "@/request/api";
import {
		mapMutations
	} from "vuex"
export default {
  data() {
    return {
      navList: [
        {
          name: "移动端",
        },
        {
          name: "民宿酒店",
        },
        {
          name: "资讯问答",
        },
        {
          name: "关于平台",
        },
        {
          name: "个人中心",
        },
        // {
        //   name: "民宿酒店入驻",
        // },
        
      ],
      udata:{},
      http:this.$ImgHttp,
      FriendlyLink:[]
    };
  },
  mounted() {
    this.about();
    this.getFriendlyLink();
  },
  methods: {
    ...mapMutations(['getIsActive']),
    onIsActive(i){
      this.getIsActive(i)
    },
    getFriendlyLink(){
      getFriendlyLink().then((res) => {
        if(res.data.code == 1){
          this.FriendlyLink = res.data.data.data
        }
      }).catch((err) => {
        
      });
    },
    about() {
      about()
        .then((res) => {
          // console.log(res);
          if(res.data.code == 1){
            this.udata = res.data.data
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 30px 360px;
  background: #333333;
  color: #ffffff;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ul {
      h1 {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 30px;
      }
      li {
        font-size: 16px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 34px;
          height: 34px;
          margin-right: 9px;
        }
        a{
          color: #ffffff;
        }
      }
    }
    .code {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      div {
        width: 100px;
        text-align: center;
        img {
          width: 100%;
          height: 100px;
        }
        p {
          font-size: 14px;
          margin-top: 15px;
        }
      }
      h6 {
        font-size: 16px;
        margin-top: 30px;
      }
    }
  }
  .Links {
    padding: 30px 0;
    border-top: 1px solid #ffffff;
    border-bottom: 1px solid #ffffff;
    display: flex;
    align-items: center;
    a{
      margin-left: 15px;
      font-size: 16px;
      color: #ffffff;
    }
    h1 {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .RecordNo {
    font-size: 18px;
    margin-top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/index.vue